import { StudyThreadRole } from '@@types/api.types';
import { type BadgeProps } from '@components/ui/badge';

const THREAD_ROLE_LABELS: Readonly<Record<StudyThreadRole, string>> = {
  [StudyThreadRole.PRIMARY]: 'Primary',
  [StudyThreadRole.SHAPING]: 'Shaping',
  [StudyThreadRole.SUPPORTING]: 'Supporting',
};

const THREAD_ROLE_BADGE_VARIANTS: Readonly<Record<StudyThreadRole, BadgeProps['variant']>> = {
  [StudyThreadRole.PRIMARY]: 'success',
  [StudyThreadRole.SHAPING]: 'pending',
  [StudyThreadRole.SUPPORTING]: 'primary',
};

export const getStudyThreadRoleLabel = (role: StudyThreadRole): string => THREAD_ROLE_LABELS[role];

export const getStudyThreadRoleBadgeVariant = (role: StudyThreadRole): BadgeProps['variant'] =>
  THREAD_ROLE_BADGE_VARIANTS[role];
